import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// avoid `!` / `as` - do a runtime check instead
const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  rootEl
);